module.exports = new __parcel__URL__("rarity.b9fa8814.png").toString();